import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import Eye from "../assets/eye.svg";
import Input from "../form-components/Input";
import Header from "./Header";
import "./styles/login.css";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { reset_sessions, sessions, logout, select_customer } from "../actions/auth/Action";
import { toast } from "react-toastify";
import moment from "moment";
import { LOGOUT } from "../config/helper";
import { Checkbox, Input as InputA } from "antd";
import { useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import endpoint from "../config/endpoint";
import { apis } from "../config/apis";
import { startIdleTimer } from "../config/helper.js";

const LoginSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  password: Yup.string().required("Password is required."),
});
export const HomeWrapper = (props) => {
  return (
    <div className="login flex-end">
      <Header />
      <div className="w45 login-form">
        <div className="w100">
          {props.children}
          <div className="footer-text">
            <span className="text-sub-heading">
              Don’t have an account yet?{" "}
            </span>
            <a href="mailto:info@omni-united.com">
              <span>Contact Administrator</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Login = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const loginRes = useSelector((state) => state.auth.sessions);
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const selectCustomerRes = useSelector((state) => state.auth.select_customer);
  const maintainace = useSelector(
    (state) => state.orders?.products?.maintainace
  );
  const [sessionToken, setSessionToken] = useState(""); // STEP 1: Store session token
  const [checked, setChecked] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    onSubmit: (vals) => {
      if (!checked) {
        toast.error(
          "Please select the checkbox of terms and privacy policy after reading."
        );
        return;
      }
      let encrypt = new window.JSEncrypt();
      const timestamp = Math.floor(Date.now() / 1000);
      const rawPassword = `${vals.password}::${timestamp}`;
      let public_key = `-----BEGIN PUBLIC KEY-----
      MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAufZoUR34EplEDxMYH/Om
      kePykev3ECzrKdRTZct7D+d4gTXNo/qi1eBDIJP/o3XG240Vc41jJMQ1m2EOnSN/
      6+oKOnd3vZ7Dh8lGmeCkelq9vYfUvM3kwqfDmz1XMZALhg7pOJiIxyY1ujl9+mpt
      Fp4gwVk1BBDmsWKciToZED6pQphr79DKuJUnics2W+RvvYZdR1pYgmB6tkWLOlB2
      vK90tR6faI2gY+DlgrsTLALPp1QorrLXlr88C+kul8VY0qHf1legf+vwSJdxokJa
      5muLjheR/hxYqJHGF10dteze0pq+rBcUnbz+ieKj8Ho3hOj42F27y0fQHPlx6QSf
      nQIDAQAB
      -----END PUBLIC KEY-----
      `;
      encrypt.setPublicKey(public_key);
      vals.password = encrypt.encrypt(rawPassword);
      // vals.isSupport = vals.email?.includes("support@")
      dispatch(sessions(vals));
    },
    validationSchema: LoginSchema,
  });

  const onLoginSuccess = (customer, authentication_token, expires_at, support_email) => {
    localStorage.setItem("token", authentication_token);
    localStorage.setItem("email", customer?.sap_id);
    localStorage.setItem("c_email", customer?.email);
    if (support_email) localStorage.setItem("s_email", support_email);
    localStorage.setItem("region", customer?.region);
    localStorage.setItem("payment_term", customer?.zterm_txt);
    localStorage.setItem("delivery_term", customer?.inco1_txt);
    localStorage.setItem("kdgrp_txt", customer?.kdgrp_txt);
    localStorage.setItem("kdgrp", customer?.kdgrp);
    localStorage.setItem("expiresAt", expires_at);
    localStorage.setItem("cartId", customer?.cart_id ? customer?.cart_id : "");
    localStorage.setItem(
      "shipping_addresses",
      JSON.stringify(customer?.shipping_addresses)
    );
    localStorage.setItem("user_type", customer.user_type || "");
    localStorage.setItem("permissions", JSON.stringify(customer.permissions || {}));
    localStorage.setItem("delegate_details", JSON.stringify(customer.delegate_details || {}));

    if (customer?.delegate_details) {
      const delegateData = {
        delegate_details: {
          id: customer.delegate_details.id || "",
          name: customer.delegate_details.name || "",
          email: customer.delegate_details.email || ""
        }
      };
      localStorage.setItem("delegate_detials", JSON.stringify(delegateData));
    }

        const onLoginTimeout = () => {
        const email = localStorage.getItem("email") || customer?.sap_id;

        dispatch(logout({ email }));

        // Delay clearing to ensure logout API gets token
        setTimeout(() => {
          localStorage.clear();
          toast.info("Session expired due to inactivity.");
          history.push("/");
        }, 1000); // wait 1s before clearing (enough for logout API)
    };
      startIdleTimer(onLoginTimeout);

    if (formik.values.email !== "it_support@omni-united.com") {
      endpoint.post(
        apis.last_login,
        {
          email: customer?.sap_id,
        },
        {
          params: {
            email: customer?.sap_id,
          },
        }
      );
    }

    dispatch({
      type: LOGOUT,
      payload: false,
    });
    dispatch(reset_sessions());
    let timeout = setTimeout(() => {
      history.push(
        location?.state?.from ? location?.state?.from : "/dashboard"
      );
      clearTimeout(timeout);
    }, 100);
  };

  useEffect(() => {
    if (loginRes && loginRes.success) {
      const data = loginRes.data;

      if (!data?.under_maintainance) {
        toast.success("Login Success");
      }

      // If 1 customer, auto-select it
      if (data?.customers?.length === 1) {
        dispatch(select_customer({
          session_token: data.session_token,
          customer_id: data.customers[0].id
        }));
      } 
      // If multiple customers, show selection screen
      else if (data?.customers?.length > 1) {
        const cust_id = new URLSearchParams(location?.state?.search);
        if (cust_id?.get("cust_id")) {
          // Auto-select if customer ID provided in URL
          const selectedCust = data.customers.find(
            (ele) => parseInt(ele?.sap_id) === parseInt(cust_id?.get("cust_id"))
          ) || data.customers[0];

          dispatch(select_customer({
            session_token: data.session_token,
            customer_id: selectedCust.id
          }));
        } else {
          // Store session token and show customer list
          setSessionToken(data.session_token);
          setCustomers(data.customers);
        }
      }
    }

    if (loginRes && loginRes.success === false) {
      toast.error(loginRes?.data?.message);
      dispatch(reset_sessions());
    }
    // eslint-disable-next-line
  }, [loginRes]);

  useEffect(() => {
    if (selectCustomerRes && selectCustomerRes.success) {
      // NEW: Step 2 returns JWT token + full customer details
      const { customer, authentication_token, expires_at } = selectCustomerRes.data;
      
      onLoginSuccess(customer, authentication_token, expires_at, formik.values.email);
    }

    if (selectCustomerRes && selectCustomerRes.success === false) {
      toast.error(selectCustomerRes?.data?.message || "Session expired. Please login again.");
      // Reset to login screen
      setCustomers([]);
      setSessionToken("");
      formik.resetForm();
      dispatch(reset_sessions());
    }
    // eslint-disable-next-line
  }, [selectCustomerRes]);

  return (
    <HomeWrapper>
      <form className="flex-center" onSubmit={formik.handleSubmit}>
        <div>
          <div
            className={
              customers?.length > 1 ? "head-sec more-custs" : "head-sec "
            }
          >
            <h3 className="text-heading">
              {customers?.length > 1
                ? "Please select the company you want to login"
                : "Welcome Back"}
            </h3>
            <span className="text-sub-heading">
              {customers?.length > 1
                ? "Please select the customer with which you want to log in."
                : "Please sign in to your account."}
            </span>
          </div>
          {customers?.length > 6 && (
            <InputA
              className="cust-search mb1"
              placeholder="Customer Search By Name"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          )}
          {customers?.length > 1 ? (
            <ul className="custs">
              {customers
                ?.filter(
                  (ele) =>
                    ele.name?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    !search
                )
                ?.map((ele) => {
                  return ele.name ? (
                    <li 
                      key={ele.id}
                      onClick={() => {
                        // Dispatch STEP 2 saga
                        dispatch(select_customer({
                          session_token: sessionToken,
                          customer_id: ele.id
                        }));
                      }}
                      className={selectCustomerRes?.loading ? "disabled" : ""}
                    >
                      {ele.name}
                      {selectCustomerRes?.loading}
                      <ArrowRightOutlined />
                    </li>
                  ) : null;
                })}
            </ul>
          ) : maintainace ? (
            <h5 className="text-heading">
              System under maintainace.
              <br /> Please Come back after some time.
            </h5>
          ) : (
            <>
              {/* LOGIN FORM SCREEN */}
              <Input
                placeholder={"Enter email"}
                formik={formik}
                name="email"
                type="email"
                disabled={loginRes?.loading}
              />
              <Input
                placeholder="Enter password"
                icon={Eye}
                formik={formik}
                name="password"
                type="password"
                disabled={loginRes?.loading}
              />
              <div className="terms">
                <Checkbox
                  checked={checked}
                  onChange={(e) => {
                    setChecked(e.target.checked);
                  }}
                  disabled={loginRes?.loading}
                />
                I have agreed to the{" "}
                <span
                  className="cursor"
                  onClick={() => {
                    window.open("terms-and-conditions", "_blank");
                  }}
                >
                  Terms of Conditions
                </span>{" "}
                and{" "}
                <span
                  className="cursor"
                  onClick={() => {
                    window.open(
                      "https://www.omni-united.com/privacy-policy",
                      "_blank"
                    );
                  }}
                >
                  Privacy Policy
                </span>
              </div>
              <div className="v-center mt2">
                <button
                  className={`primary-btn mr1 ${
                    loginRes?.loading ? "loadBtn" : ""
                  }`}
                  type="submit"
                  disabled={loginRes?.loading}
                >
                  {loginRes?.loading ? "Processing..." : "Login"}
                </button>
                <span
                  className="p-link"
                  onClick={() => {
                    if (!loginRes?.loading) {
                      history.push("/reset-password");
                    }
                  }}
                >
                  Forgot password ?
                </span>
              </div>
            </>
          )}
        </div>
      </form>
    </HomeWrapper>
  );
};

export default Login;
